import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";

var _class, _descriptor;

import { observable, runInAction } from "mobx";
import { BaseOptions } from "@devowl-wp/utils";
let OptionStore = (_class = class OptionStore extends BaseOptions {
  constructor(rootStore) {
    super();

    _initializerDefineProperty(this, "others", _descriptor, this);

    this.pureSlug = void 0;
    this.pureSlugCamelCased = void 0;
    this.rootStore = void 0;
    this.rootStore = rootStore;
    this.pureSlug = BaseOptions.getPureSlug(process.env.slug);
    this.pureSlugCamelCased = BaseOptions.getPureSlug(process.env.slug, true); // Use the localized WP object to fill this object values.

    runInAction(() => Object.assign(this, window[this.pureSlugCamelCased]));
  }

}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "others", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { OptionStore };